import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  canShowIntegrationViewBridge,
  getIntegrationMode,
} from '../../app/helpers/semanticSearchConfigHelper';
import { startRegisterUserInterest } from '../../app/actions/userInterestActions';
import IntegrationResultsPanel from './IntegrationResultsPanel';
import {
  IntegrationNestedPreviewContext,
  useIntegrationNestedPreview,
} from './integrationNestedPreviewContext';
import VerticalToolbar from './VerticalToolbar';
import { MODULE_INTEGRATION_META } from './moduleIntegrationMeta';

// Re-export para imports existentes
export { IntegrationNestedPreviewContext, useIntegrationNestedPreview };

/**
 * VerticalToolbar (variant view) + panel integrado para páginas View/Preview (1 registro).
 */
const IntegrationViewChrome = ({ sourceModuleKey, record }) => {
  const { nested } = useIntegrationNestedPreview();
  const dispatch = useDispatch();
  const configuration = useSelector((state) => state.configuration);
  const [integrationOpen, setIntegrationOpen] = useState(false);
  const [targetModule, setTargetModule] = useState(null);

  const meta = MODULE_INTEGRATION_META[sourceModuleKey];
  const originItems = useMemo(() => {
    if (!record?.id) return [];
    return [
      {
        id: record.id,
        name: record[meta?.nameField] || record.name || record.theme || null,
      },
    ];
  }, [record, meta]);

  const visible = canShowIntegrationViewBridge(configuration, sourceModuleKey);
  if (nested || !visible || !record?.id) return null;

  const mode = getIntegrationMode(configuration);

  const onIntegrationClick = (targetKey) => {
    setTargetModule(targetKey);
    setIntegrationOpen(true);
    if (record?.id) {
      dispatch(
        startRegisterUserInterest({
          event_type: 'bridge_click',
          sourceModule: sourceModuleKey,
          targetModule: targetKey,
          originIds: [record.id],
          bridge_kind: 'view',
          searchText:
            typeof localStorage !== 'undefined'
              ? localStorage.getItem('searchTextLocal') || ''
              : '',
        })
      );
    }
  };

  return (
    <>
      <VerticalToolbar
        hasRecords
        moduleSelected={{ key: sourceModuleKey }}
        onIntegrationClick={onIntegrationClick}
        variant="view"
      />

      <IntegrationResultsPanel
        isOpen={integrationOpen}
        onClose={() => setIntegrationOpen(false)}
        sourceModuleKey={sourceModuleKey}
        targetModule={targetModule}
        originItems={originItems}
        searchText={
          typeof localStorage !== 'undefined' ? localStorage.getItem('searchTextLocal') || '' : ''
        }
        mode={mode}
        bridgeKind="view"
      />
    </>
  );
};

export default IntegrationViewChrome;
